Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constants = require('./constants');

var _formatNumber = require('./formatNumber');

var _formatNumber2 = _interopRequireDefault(_formatNumber);

var _ethjsUnit = require('ethjs-unit');

var _ethjsUnit2 = _interopRequireDefault(_ethjsUnit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Format a number of wei to another ethereum unit.
 *
 * @param {String|Number|BN} number the number of wei to format
 * @param {String} format see http://numeraljs.com for examples
 * @param {String} unit any ethereum units see https://github.com/ethjs/ethjs-unit#supported-units for supported units
 * @param {Object} options
 *  {String} etherSymbol if unit is `ether` will use this symbol for the unit instead (Ξ by default)
 *  {String} locale a custom local (*en* by default)
 */
exports['default'] = function (number) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0,0.[00000000] $';
  var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ether';
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _constants.DEFAULT_OPTIONS;

  options = Object.assign({}, _constants.DEFAULT_OPTIONS, options);

  return (0, _formatNumber2['default'])(_ethjsUnit2['default'].fromWei(number, unit.toLowerCase()), format, unit, options);
};

module.exports = exports['default'];
//# sourceMappingURL=formatWei.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ethtools/build/formatWei.js
// module id = kLTR
// module chunks = 0